import axios from "axios";

const createDynamicLink = async (link, description) => {
  const apiKey = "AIzaSyBL8IRKJoHXtGelTXyxrZLFTnscMSOI2Xs"; // Your API Key
  const dynamicLinksUrl = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${apiKey}`;

  const payload = {
    dynamicLinkInfo: {
      domainUriPrefix: "https://gowell.page.link",
      link: link,
      androidInfo: {
        androidPackageName: "com.gowell.br",
      },
      iosInfo: {
        iosBundleId: "com.gowell.br",
      },
      socialMetaTagInfo: {
        socialTitle: "Radio USTAWI Campaign",
        socialDescription: description,
      },
    },
  };

  try {
    const response = await axios.post(dynamicLinksUrl, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = response.data;
    if (data.shortLink) {
      console.log("Generated Dynamic Link:", data.shortLink);
      return data.shortLink;
    } else {
      throw new Error("Failed to create dynamic link");
    }
  } catch (error) {
    console.error("Error creating dynamic link:", error.response?.data || error.message);
    return null;
  }
};

export default createDynamicLink;
